import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogData } from 'src/app/shared/components/dialogs/dialog-data';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
})
export class DialogComponent implements OnInit {
    client!: string;
    returnedValue: any;
    todayDate: Date;

    get dateString(): string {
        return this.todayDate.toISOString().split('T')[0];
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
        private dialogRef: MatDialogRef<DialogComponent>
    ) {
        this.todayDate = new Date();
        this.todayDate.setHours(12);
        if (this.data.field == 'date') {
            if (this.data.dateValue) {
                let date = new Date(this.data.dateValue);
                date.setHours(12);
                if (date < this.todayDate) {
                    date = this.todayDate;
                }
                this.returnedValue = date.toISOString().split('T')[0];
            } else {
                this.returnedValue = this.dateString;
            }
        }
    }

    ngOnInit(): void {
        this.client = environment.client;
    }

    cancel() {
        this.dialogRef.close();
    }

    confirmer() {
        if (this.data.frame) {
            if (this.data.field == 'date' && this.returnedValue) {
                const dateResp = new Date(this.returnedValue);
                dateResp.setHours(12);
                this.dialogRef.close(dateResp);
            } else {
                this.dialogRef.close(this.returnedValue);
            }
        } else {
            this.dialogRef.close(true);
        }
    }
}
